module.exports = __webpack_public_path__ + "static/media/thermohug-5.eb2a12ad.jpg";